import { Component } from '@angular/core';
import { DataServiceService } from '../../services/data-service.service';

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrl: './country.component.scss',
})
export class CountryComponent {
  countryDataSource: any;

  constructor(private dataService: DataServiceService) {
    this.countryDataSource = dataService.getCountryDataSource();
  }
}
